<div class="page">
	<img
		src="../../../../../assets/svg/bcb-group-stacked-gradient.svg"
		width="250"
		height="250"
		alt="Bcb group logo"
	/>
	<div class="loading">
		<mat-spinner></mat-spinner>
		<h2>Loading...</h2>
	</div>
</div>
